<template>
  <div>
    <div class="banner" id="banner">
      <div class="banner-container" style="position: relative">
        <div class="homeFontStyle">
          <div class="travelXFont">Travel-X</div>
          <div class="travelXContent">
            {{ $t("home.travelx_one") }}
          </div>
          <div class="travelXContent">
            {{ $t("home.travelx_two") }}
          </div>
        </div>
        <div class="home_right">
          <img src="../../public/static/img/home/right.png" alt="" />
        </div>
      </div>
    </div>
    <div class="about-us pb100 mt375" style="position: relative">
      <div class="aboutUs_widthHeight">
        <img src="../../public/static/img/home/home_left.png" alt="" />
      </div>
      <div class="homeTravel_widthHeight">
        <img src="../../public/static/img/home/home-travel.png" alt="" />
      </div>
      <div class="data-wrap" style="" v-number>
        <div class="col-4 data" style="padding: 0; justify-content: center">
          <span
            class="number-container"
            v-for="(item, index) in '228'"
            :key="index"
          >
            <span class="number-wrap"
              ><span
                v-for="(n, ele) in parseInt(item) + 1"
                :key="ele"
                class="number-item"
                >{{ n - 1 }}</span
              ></span
            >
          </span>
          <span class="number-container">M</span>
        </div>
        <div class="col-4 data" style="padding: 0; justify-content: center">
          <span
            class="number-container"
            v-for="(item, index) in '95'"
            :key="index"
          >
            <span class="number-wrap"
              ><span
                v-for="(n, ele) in parseInt(item)"
                :key="ele"
                class="number-item"
                >{{ n }}</span
              ></span
            >
          </span>
          <span class="number-container">%</span>
        </div>
        <div class="col-4 data" style="padding: 0; justify-content: center">
          <span class="number-container">1.</span>
          <span
            class="number-container"
            v-for="(item, index) in '9'"
            :key="index"
          >
            <span class="number-wrap"
              ><span
                v-for="(n, ele) in parseInt(item)"
                :key="ele"
                class="number-item"
                >{{ n }}</span
              ></span
            >
          </span>
          <span class="number-container">M</span>
        </div>
        <div class="col-4 data" style="padding: 0; justify-content: center">
          <span
            class="number-container"
            v-for="(item, index) in '99'"
            :key="index"
          >
            <span class="number-wrap"
              ><span
                v-for="(n, ele) in parseInt(item)"
                :key="ele"
                class="number-item"
                >{{ n }}</span
              ></span
            >
          </span>
          <span class="number-container">M</span>
        </div>
      </div>
      <div class="desc-wrap">
        <div class="col-4 desc">
          {{ $t("home.col1") }}
        </div>
        <div class="col-4 desc">
          {{ $t("home.col2") }}
        </div>
        <div class="col-4 desc">
          {{ $t("home.col3") }}
        </div>
        <div class="col-4 desc">
          {{ $t("home.col4") }}
        </div>
      </div>
    </div>

    <!-- 解决方案 -->
    <div class="banner_box_media pb300" style="background-color: #f0ede4">
      <div class="banner_center_media">
        <div class="mb70">
          <div class="banner_title">{{ $t("home.solution") }}</div>
          <div class="banner_content">
            {{ $t("home.s1") }}<span>{{ $t("home.s2") }}</span
            >{{ $t("home.s3") }}<span>{{ $t("home.s4") }}</span>
          </div>
          <div class="banner_content">
            {{ $t("home.solu1") }}<span>{{ $t("home.solu2") }}</span>
          </div>
        </div>

        <div class="banner_portus">
          <div class="portus_box">
            <img src="../../public/static/img/home/Portus.png" alt="" />
            <div>
              <div class="portus_word">Portus</div>
              <hr />
              <div class="word" style="margin-bottom: 100px">
                {{ $t("home.solution1") }}
              </div>
            </div>
          </div>
          <div class="portus_box">
            <img src="../../public/static/img/home/PortusAir.png" alt="" />
            <div>
              <div class="portus_word">PortusAir</div>
              <hr />
              <div class="word" style="margin-bottom: 80px">
                {{ $t("home.solution2") }}
              </div>
            </div>
          </div>
          <div class="portus_box">
            <img src="../../public/static/img/home/PortusPlus.png" alt="" />
            <div>
              <div class="portus_word">PortusPlus</div>
              <hr />
              <div class="word" style="margin-bottom: 80px">
                {{ $t("home.solution3") }}
              </div>
            </div>
          </div>
          <div class="portus_box">
            <img src="../../public/static/img/home/PortusFin.png" alt="" />
            <div>
              <div class="portus_word">PortusFin</div>
              <hr />
              <div class="word" style="margin-bottom: 80px">
                {{ $t("home.solution4") }}
              </div>
            </div>
          </div>
        </div>

        <div
          class="learnMore learnMore1"
          @click="$router.push('solution?type=portus')"
        >
          {{ $t("home.more") }}
          <div class="goLearnMore">
            <img
              class="mt13"
              src="../../public/static/img/home/learnMore.png"
              alt=""
            />
          </div>
        </div>
        <div
          class="learnMore learnMore2"
          @click="$router.push('solution?type=portusAir')"
        >
          {{ $t("home.more") }}
          <div class="goLearnMore">
            <img
              class="mt13"
              src="../../public/static/img/home/learnMore.png"
              alt=""
            />
          </div>
        </div>
        <div class="learnMore learnMore3" @click="$router.push('media')">
          {{ $t("home.more") }}
          <div class="goLearnMore">
            <img
              class="mt13"
              src="../../public/static/img/home/learnMore.png"
              alt=""
            />
          </div>
        </div>
        <div
          class="learnMore learnMore4"
          @click="$router.push('solution?type=portusFin')"
        >
          {{ $t("home.more") }}
          <div class="goLearnMore">
            <img
              class="mt13"
              src="../../public/static/img/home/learnMore.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 全球旅行购 -->
    <div class="banner_box_media" style="background-color: #f7f7f5">
      <div class="banner_center_media dfsb">
        <div class="banner_left">
          <div class="left_top">
            <img src="../../public/static/img/home/travelgo.png" alt="" />
          </div>
          <div class="left_bottom">
            <div class="font32">
              {{ $t("home.travel") }}
            </div>
            <hr />
            <div class="travelFont">
              {{ $t("home.travel1")
              }}<span class="fontweight">{{ $t("home.travel2") }}</span
              >{{ $t("home.travel3")
              }}<span class="fontweight">{{ $t("home.travel4") }}</span>
            </div>
          </div>
        </div>
        <div class="banner_right">
          <el-carousel :interval="5000" arrow="never">
            <el-carousel-item v-for="(item, index) in swiperList" :key="index">
              <img :src="item" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <!-- 图片 -->
      <div>
        <img
          style="width: 100%"
          src="../../public/static/img/home/travel-bottom.png"
          alt=""
        />
      </div>

      <div style="display: flex">
        <div class="leftImg_widthHeight">
          <img src="../../public/static/img/home/home_left.png" alt="" />
        </div>

        <div class="margin_auto">
          <div class="fz70">
            {{ $t("home.customer_case") }}
          </div>

          <div class="banner_portus carousel" ref="all">
            <div
              v-for="(item, index) in tableData"
              :key="index"
              class="carousel-item"
              :style="'transform: translateX(' + item.translateNum + 'px)'"
              ref="demoItem"
            >
              <div
                @mouseover="mouseOver(index)"
                @mouseleave="mouseLeave('')"
                class="customer_case carousel-item"
                ref="_width"
              >
                <div
                  class="case_top"
                  :style="{
                    borderRadius:
                      isShowIndex === index ? '20px 20px 0 0' : '20px',
                  }"
                >
                  <div class="case_top_img">
                    <img :src="item.img" alt="" />
                  </div>
                </div>
              </div>
              <div class="case_content" v-show="isShowIndex === index">
                {{ item.word }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data () {
    return {
      father_width: '',
      son_width: '',
      timer: null,
      translateNum: 0,
      isShowIndex: '',
      swiperList: [
        'http://travelmall.portus.cn/2023/04/0dedf586ba21431795d126872cdc954a.png',
        'http://travelmall.portus.cn/2023/04/5e14b2bc14ea4354853606bad5c101af.png',
        'http://travelmall.portus.cn/2023/04/c896c20e4b78480cb9e409e767a9f528.png',
        'http://travelmall.portus.cn/2023/04/0dedf586ba21431795d126872cdc954a.png',
        'http://travelmall.portus.cn/2023/04/5e0168e48adb4e59b6fe61032d8287c6.png'
      ],
      tableData: [
        {
          img: 'http://travelmall.portus.cn/2023/04/c18b50419dce422ea636e3fc8f1b308c.png',
          word: this.$i18n.t('home.swiper1')
        },
        {
          img: 'http://travelmall.portus.cn/2023/04/601a4f705461426d96b80468175bc2d5.png',
          word: this.$i18n.t('home.swiper2')
        },
        {
          img: 'http://travelmall.portus.cn/2023/04/b23cc72fc8244c98af5f8c066d115544.png',
          word: this.$i18n.t('home.swiper3')
        },
        {
          img: 'http://travelmall.portus.cn/2023/04/4ffec8a3b3f0482796d6608586627c07.png',
          word: this.$i18n.t('home.swiper4')
        },
        {
          img: 'http://travelmall.portus.cn/2023/04/5c0d4a582a0041ce8c142368345536a2.png',
          word: this.$i18n.t('home.swiper5')
        }
      ]
    }
  },
  mounted () {
    this.search();
  },
  beforeDestroy () {
    // 销毁定时器，否则可能导致重载此组件时会有多个定时器同时执行，使得滚动变快
    window.clearTimeout(this.timer);
  },
  created () {
    this.$nextTick(() => {
      this.father_width = this.$refs.all.offsetWidth
      this.son_width = this.$refs._width[0].offsetWidth
    })
  },
  methods: {
    search () {
      // 循环给tableData数组每一个对象添加translateNum属性为0，这也是为了方便记录每一个对象滚动的宽度
      for (var i = 0; i < this.tableData.length; i++) {
        this.$set(this.tableData[i], 'translateNum', 0);
      }

      // 在元素完全渲染后再循环给每一个对象添加indexLeft属性，记录此对象初始位置，方便滚动超出父元素边界后，重新设置元素位置
      this.$nextTick(() => {
        for (var j = 0; j < this.tableData.length; j++) {
          this.$set(this.tableData[j], 'indexLeft', this.$refs.demoItem[j].offsetLeft);
        }

        // 调用滚动定时器
        this.roll();
      })
    },

    roll () {
      this.timer = setInterval(() => {
        // 循环给每一个对象修改translateNum属性值，从而动态修改页面元素的transform样式，达到滚动的效果
        for (var i = 0; i < this.tableData.length; i++) {

          /**
           * 判断此元素是否即将超出父级元素carousel-item的显示区域
           * 1400 = 父级元素carousel的宽度 + 一个子元素carousel-item的宽度（如果元素有间距也需要带上）即 1200 + 180 + 20(间距) 
           * 修改父级元素与子元素样式时需要留意此处也应当一起修改
           */
          if (this.father_width + this.son_width - 140 - this.tableData[i].translateNum - this.tableData[i].indexLeft < 0) {

            /**
             * 如果超出，则将元素移动至父级元素显示区域的左方
             * 此处的200 对应着子元素carousel-item的样式宽度
             */
            this.$set(this.tableData[i], 'translateNum', this.$refs.all.offsetLeft - this.tableData[i].indexLeft - this.son_width - 90);
          }

          // 设置每个元素每次滚动的像素大小，像素越小越平滑,这里每次只移动一个像素
          this.$set(this.tableData[i], 'translateNum', this.tableData[i].translateNum + 1);

        }
      }, 30); // 30毫秒滚动一次，时间间隔越短滚动越平滑

    },

    /**
     * 鼠标悬停销毁定时器
     */
    mouseOver (index) {
      window.clearTimeout(this.timer);
      this.isShowIndex = index
    },

    /**
     * 鼠标离开再次执行定时器
     */
    mouseLeave (index) {
      this.roll();
      this.isShowIndex = index
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/ .el-carousel__container {
  width: 415px;
  height: 876px;
}
.carousel {
  // background-color: gray;
  width: 1400px;
  height: 430px;
  margin: auto;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.carousel-item {
  width: 350px;
}
/deep/ .el-carousel__button {
  background-color: #000;
}
.clear {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.banner .banner-container {
  padding-top: 86px;
  min-height: 780px;
  background-image: url("https://travelmall.portus.cn/2023/04/b567cf73f8e74399a884140fa4f28d5c.png");
  background-repeat: no-repeat center;
  background-size: 100% 100%;
}
.about-us {
  &:after {
    .clear;
  }
  .map {
    width: 52%;
    float: left;
    img {
      width: 100%;
    }
  }
  .data-wrap {
    width: 1300px;
    margin: auto;
    margin-top: 100px;
    .data {
      display: flex;
      // justify-content: center;
      // text-align: center;
      .number-container {
        position: relative;
        color: #fff;
        width: 82px;
        height: 100px;
        font-size: 92px;
        background-color: #000;
        margin-right: 10px;
        text-align: center;
        line-height: 100px;
        overflow: hidden;
        .number-wrap {
          display: block;
          position: relative;
        }
        &:last-child {
          margin-right: 0;
        }
        .number-item {
          line-height: 100px;
          display: block;
        }
      }
    }
  }
  .desc-wrap {
    width: 1300px;
    margin: auto;
    .desc {
      font-size: 24px;
      font-weight: 600;
      padding-top: 20px;
      padding-left: 25px;
      line-height: 30px;
      text-align: center;
      font-family: "RobotoSlab-Regular" !important;
    }
  }
}
</style>


